import React from "react";
import {withRouter} from "react-router-dom"
import style from "./serverError.module.scss"
import Button from "../../Components/Button/button";
import error from "../../assets/icons/500.svg"
import mobisha from "../../assets/icons/mobisha.svg"

const serverError = (props) => {

    return (
        <div className={style.wrapper}>
            <div className={style.row}>
                <div className={style.box}>
                    <div className={style.left}>
                        <img src={error} alt=""/>
                    </div>
                    <div className={style.right}>
                        <div className={style.container}>

                            <div className={style.title}>خطای ۵۰۰</div>
                            <div className={style.bold}> سرور از دسترس خارج است</div>
                            <div className={style.text}> متاسفانه مشکل از سمت ماست و سرور از دسترس خارج شده. الان
                                نمی‌تونیم صفحه‌ی مورد نظرتون رو بیاریم، لطفا یه کم بعد دوباره تلاش کنین.
                            </div>
                            <div className={style.buttonWrapper}>
                                <Button type="solid" label="بازگشت به خانه" onClick={() => {
                                    props.history.push("/")
                                }}/>
                                <Button type="outline" label="نمایش داشبورد" onClick={() => {
                                    props.history.push("/")
                                }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={style.subtitle}>
                <img src={mobisha} alt="" className={style.image}/>
                <div className={style.text}>موبیشا | ربات قیمت‌گذاری دیجی‌کالا</div>
            </div>


        </div>
    )
}
export default withRouter(serverError);



